import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgWechatpay({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.054 8.166c-.06-.1-.105-.103-.199-.045-.31.19-.627.373-.942.556l-2.411 1.397c-.951.552-1.903 1.103-2.852 1.656l-4.028 2.353c-.375.22-.734.101-.913-.298-.15-.334-.303-.667-.454-1-.39-.87-.782-1.74-1.171-2.61-.072-.16-.045-.276.074-.376.112-.095.246-.095.385.005.626.45 1.25.904 1.879 1.35.282.2.59.229.91.086.816-.364 1.633-.728 2.449-1.095 1.157-.52 2.313-1.045 3.47-1.566.98-.441 1.96-.882 2.943-1.317.127-.057.136-.1.046-.202a8.598 8.598 0 00-2.573-1.97 10.034 10.034 0 00-2.845-.942c-.601-.106-1.209-.173-1.777-.14a9.513 9.513 0 00-2.336.237 9.88 9.88 0 00-1.765.558c-1.529.65-2.811 1.615-3.762 3A6.558 6.558 0 003 11.535c-.005.63.09 1.25.272 1.858.36 1.198 1.014 2.209 1.894 3.081.3.298.626.563.96.82.205.16.276.375.217.616-.12.492-.262.978-.395 1.467l-.065.248a.288.288 0 00.113.321c.115.083.245.063.367-.008.648-.377 1.296-.753 1.945-1.128.19-.109.39-.19.614-.145.166.033.33.08.494.125a9.28 9.28 0 002.144.312c.736.025 1.468-.012 2.198-.134a9.9 9.9 0 001.78-.457c1.052-.386 2.026-.918 2.883-1.655 1.192-1.025 2.03-2.273 2.404-3.821a6.413 6.413 0 00.092-2.52 6.6 6.6 0 00-.863-2.349z"
        fill="#000"
      />
    </svg>
  )
}

export default SvgWechatpay
